import $ from 'jquery';

export default class QuestionsAnswers {
    constructor() {
        $('.product-questions-answers .pqa-ask-question').click((e) => {
            $('.ywqa-ask-question').slideToggle();
            $(e.target).hide();

            e.preventDefault();
        })
    }
}

new QuestionsAnswers();